var render, staticRenderFns
import script from "./AolSelect.vue?vue&type=script&lang=js"
export * from "./AolSelect.vue?vue&type=script&lang=js"
import style0 from "./AolSelect.vue?vue&type=style&index=0&id=5b5f21d9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports